import React, { createContext, useState, useRef, useContext, useEffect } from 'react';

export const CallContext = createContext();

export const CallProvider = ({ children }) => {
  const [isInCall, setIsInCall] = useState(false);
  const [callData, setCallData] = useState(null);
  const [isCallConnected, setIsCallConnected] = useState(false); // Nouveau state
  
  // Refs pour persister les streams et connexions entre les rendus
  const localStreamRef = useRef(null);
  const remoteStreamRef = useRef(null);
  const peerConnectionRef = useRef(null);
  const screenStreamRef = useRef(null);
  const callStartedRef = useRef(false);
  const hasSetupConnectionRef = useRef(false);

  // Nettoyer complètement au chargement de la page (en cas de rafraîchissement pendant un appel)
  useEffect(() => {
    cleanupResources();
  }, []);

  const cleanupResources = () => {
    // Nettoyer les streams
    if (localStreamRef.current) {
      localStreamRef.current.getTracks().forEach(track => {
        track.stop();
      });
      localStreamRef.current = null;
    }
    if (screenStreamRef.current) {
      screenStreamRef.current.getTracks().forEach(track => {
        track.stop();
      });
      screenStreamRef.current = null;
    }
    if (peerConnectionRef.current) {
      peerConnectionRef.current.close();
      peerConnectionRef.current = null;
    }
    if (remoteStreamRef.current) {
      remoteStreamRef.current = null;
    }

    // Réinitialiser les refs
    callStartedRef.current = false;
    hasSetupConnectionRef.current = false;
    setIsCallConnected(false);
  };

  const startCall = (data) => {
    // S'assurer que tout est nettoyé avant de commencer un nouvel appel
    cleanupResources();
    setCallData(data);
    setIsInCall(true);
    setIsCallConnected(false); // Pas encore connecté
  };

  const markCallAsConnected = () => {
    setIsCallConnected(true);
  };

  const endCall = () => {
    cleanupResources();

    // Réinitialiser les states
    setIsInCall(false);
    setCallData(null);
    setIsCallConnected(false);
  };

  return (
    <CallContext.Provider
      value={{
        isInCall,
        callData,
        isCallConnected,
        startCall,
        endCall,
        markCallAsConnected,
        localStreamRef,
        remoteStreamRef,
        peerConnectionRef,
        screenStreamRef,
        callStartedRef,
        hasSetupConnectionRef,
      }}
    >
      {children}
    </CallContext.Provider>
  );
};

export const useCall = () => {
  const context = useContext(CallContext);
  if (!context) {
    throw new Error('useCall must be used within a CallProvider');
  }
  return context;
};